import { padStart } from 'lodash'
import {parseFormula} from "@/utils/formula";
import useComputedTreeValue from "@/views/components/element/hooks/useComputedTreeValue";
import {storeToRefs} from "pinia";
import {useSlidesStore} from '@/store'


/**
 * Complement digits
 * @param digit number
 * @param len number of digits
 */
export const fillDigit = (digit: number, len: number) => {
  return padStart('' + digit, len, '0')
}

/**
 * judgment equipment
 */
export const isPC = () => {
  return !navigator.userAgent.match(/(iPhone|iPod|iPad|Android|Mobile|BlackBerry|Symbian|Windows Phone)/i)
}

export const applyRules = (element, rules) => {
  const { rulesEnabled } = storeToRefs(useSlidesStore())

  let results = {};
  let tempColor = null;
  if (rules && rulesEnabled.value) {
    element.ruleIds.forEach((ruleId) => {
      const scenarioResult = executeScenario(rules, ruleId);

      if (scenarioResult && scenarioResult.color) {
        tempColor = scenarioResult.color;
      }

      if (scenarioResult) results = { ...results, ...scenarioResult };
    });

    if (element.alternateColor !== tempColor) {
      element.alternateColor = tempColor;
    }

    return results;
  }

};

const evaluateScenarioConditions = (condition: any) => {
  const { hookId, operator, value } = condition;
  const { getValueByHookId } = useComputedTreeValue()
  const hookValue = getValueByHookId(hookId);
  const conditionValue = parseFloat(value);

  if (hookValue != null && operator) return parseFormula(`${hookValue} ${operator} ${conditionValue}`)
}

const executeScenario = (rules, ruleId) => {
  //TODO: add in OR
  const findRule = rules.find(item => item.id === ruleId)
  const allConditionsValid = findRule ? findRule.conditions.every(condition => evaluateScenarioConditions(condition)) : null;

  if (allConditionsValid && findRule) {
    return findRule.actions.style
  }
}
